import { setIsLoading, setPartnerForAccessCode, setPartners } from 'reducers/partnerReducer';
import { getPartnerDetails } from 'services/partner/getPartnerDetails';
import { fetchPartnerByNameOrNumber } from 'services/partner/fetchPartnerByNameOrNumber';
import { AppDispatch } from 'store';
import { closeModal, openModal } from 'reducers/modalReducer';

export const getPartners = (searchString: string) => async (dispatch: AppDispatch) => {
  try {
    const data = await fetchPartnerByNameOrNumber(searchString).catch((error) => {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            httpError: error,
            okHandler: () => {
              dispatch(closeModal());
            },
            technicalInfo: {
              title: 'Error when retrieving Partner',
              userErrorMessage: 'An error occurred when retrieving Partner. Please try again later.',
            },
          },
        }),
      );
      dispatch(setIsLoading(false));
      return;
    });
    if (data) {
      dispatch(setPartners(data));
    }
    dispatch(setIsLoading(false));
  } catch (e) {
    console.log(e);
    dispatch(setIsLoading(false));
    return [];
  }
};

export const getPartnerThunk = (partnerNumber: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true));
  const result = await getPartnerDetails(partnerNumber).catch((error) => {
    dispatch(
      openModal({
        modalType: 'JBErrorModalWrapper',
        modalProps: {
          httpError: error,
          okHandler: () => {
            dispatch(closeModal());
          },
          technicalInfo: {
            title: 'Error when retrieving Partner details',
            userErrorMessage: 'An error occurred when retrieving Partner details. Please try again later.',
          },
        },
      }),
    );

    return;
  });
  if (result) {
    dispatch(setPartnerForAccessCode(result));
  }
  dispatch(setIsLoading(false));
};
